import { useCallback, useEffect, useState } from 'react';
import ReactLoading from 'react-loading';
import { useNavigate, useSearchParams } from 'react-router-dom';
import EmptyPage from '../../empty-page/emptyPage';
import OrgTripList from '../../orgTripList/OrgTripList';
import Pagination from '../../pagination/Pagination';
import { countOfActivities, FetchActList } from './orgActFun/fetchActList';
import errorHandle from '../../../utils/errorHandle';

const OrgActivityPackList = () => {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const selectedStatus = searchParams.get('status') || 'active';
    const pageNumber = Number(searchParams.get('page')) || 1;
    const [loading, setLoading] = useState(false);
    const [activityData, setActivityData] = useState([]);
    const limit = 10;
    const [totalCount, setTotalCount] = useState(0);
    const offSet = (pageNumber - 1) * limit;
    const totalData = totalCount;
    const totalPages = Math.ceil(totalData / limit);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, []);

    const updateURL = useCallback(
        (params) => {
            const current = Object.fromEntries([...searchParams]);

            Object.keys(params).forEach((key) => {
                if (params[key] === '' || params[key] === null) {
                    delete current[key];
                } else {
                    current[key] = params[key];
                }
            });
            setSearchParams(current);
        },
        [searchParams, setSearchParams]
    );

    useEffect(() => {
        if (!totalPages) return;

        if (pageNumber > totalPages) {
            updateURL({ page: totalPages });
        }
        //eslint-disable-next-line
    }, [totalPages, pageNumber, updateURL]);

    const paginationClick = (number, offSetNumber) => {
        if (Math.ceil(totalData / limit) > 1) {
            updateURL({ page: number });
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    };

    useEffect(() => {
        async function fetchPackList() {
            setLoading(true);
            try {
                await FetchActList(setActivityData, selectedStatus, limit, offSet, setLoading);
            } catch (error) {
                setLoading(false);
                errorHandle(error);
            }
        }
        fetchPackList();
    }, [selectedStatus, limit, offSet]);

    useEffect(() => {
        countOfActivities(setTotalCount, selectedStatus, setLoading);
    }, [selectedStatus]);

    const handleSelect = (id) => {
        console.log(id, 'Selected trip id');
        const url = `/org/a/activity/details/${id}`;
        window.open(url, '_blank');
    };

    const handleEdit = (id) => {
        const url = `/org/a/create/pack?new=false&type=edit&tripId=${id}`;
        window.open(url, '_blank');
    };

    const handleDuplicate = (id) => {
        const url = `/org/a/create/pack?new=false&type=duplicate&tripId=${id}`;
        window.open(url, '_blank');
    };

    return (
        <div>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
            <div className='orgPack'>
                {/* discuss on whether we need filters in mybooking */}
                {/* <Filters filterData={filterDummy?.data} /> */}
                {/* <Filters filterData={[]} /> */}
                <div className='orgPackTripStrap'>
                    <div className='orgPackHeadSeaDiv alignCenter'>
                        <h1 className='orgBookingHeading'>My Activities</h1>
                        <div className='orgPackFilters'>
                            <select
                                name='date'
                                id='date'
                                className='select'
                                onChange={(e) => {
                                    updateURL({ status: e.target.value, page: 1 });
                                }}
                                value={selectedStatus}
                            >
                                <option value='active'>Approved</option>
                                <option value='inactive'>Not Approved</option>
                                <option value='rejected'>Rejected</option>
                            </select>
                            <button className='orgPackCreateBtn blueBtn' onClick={() => navigate('/org/a/create/pack')}>
                                Create {window.innerWidth < 768 ? '' : 'Activity'}
                            </button>
                        </div>
                    </div>

                    {/* {searchRe && <p>Search result for {searchRe}</p>} */}
                    {activityData?.length === 0 && !loading ? (
                        <EmptyPage />
                    ) : (
                        <>
                            <OrgTripList
                                data={activityData}
                                onSelect={handleSelect}
                                onEdit={handleEdit}
                                onDuplicate={handleDuplicate}
                                selectedStatus={selectedStatus}
                            />
                            <Pagination
                                paginationClick={paginationClick}
                                numberOfRows={totalData}
                                offSet={offSet}
                                pageNumber={pageNumber}
                                limit={limit}
                            />
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default OrgActivityPackList;
